import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { roleDefinitions } from '../data/team';

const { FiX, FiMail, FiShield, FiCheck } = FiIcons;

const InviteMemberModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Contributor');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Logic for invitation would go here
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
      >
        <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
          <h2 className="text-lg font-bold text-gray-900">Invite Team Member</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full text-gray-400 transition-colors">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Email Address</label>
            <div className="relative">
              <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input 
                required
                type="email" 
                placeholder="colleague@company.com"
                className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">Assign Role</label>
            <div className="space-y-2">
              {Object.entries(roleDefinitions).map(([key, def]) => (
                <label 
                  key={key}
                  className={`flex items-start gap-3 p-3 rounded-xl border cursor-pointer transition-all ${
                    role === key ? 'border-blue-500 bg-blue-50/50 shadow-sm' : 'border-gray-100 hover:border-gray-200'
                  }`}
                >
                  <input 
                    type="radio" 
                    name="role" 
                    className="mt-1 w-4 h-4 text-blue-600 rounded-full border-gray-300 focus:ring-blue-500"
                    checked={role === key}
                    onChange={() => setRole(key)}
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold text-gray-900">{def.label}</span>
                      {role === key && <SafeIcon icon={FiCheck} className="text-blue-600 w-3 h-3" />}
                    </div>
                    <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{def.description}</p>
                  </div>
                </label>
              ))}
            </div>
          </div>

          <div className="pt-2">
            <button 
              type="submit"
              className="w-full py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 shadow-md transition-all flex items-center justify-center gap-2"
            >
              <SafeIcon icon={FiShield} />
              Send Invitation
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default InviteMemberModal;